























































































































































































































































// ignore file for now, this is a Vue 2 component using TypeScript
// ts-ignore
// @ts-nocheck
import axios from 'axios';
import { differenceInMinutes, format, compareAsc } from 'date-fns';
import TimeEntryForm from '@/components/TimeEntryForm.vue';
import ProjectSummaries from '@/components/ProjectSummaries.vue';
import DateCellRenderer from '@/components/DateCellRenderer.vue';
import TimeCellRenderer from '@/components/TimeCellRenderer.vue';
import ActionCellRenderer from '@/components/ag-grid/ActionCellRenderer.vue';
import TagCellRenderer from '@/components/ag-grid/TagCellRenderer.vue'
import _ from 'lodash';
import vue from 'vue';

export default vue.extend({
  components: {
    TimeEntryForm,
    ProjectSummaries,
  },
  data() {
    return {
      format,
      isShowAllDates: false,
      isStartDateModalOpen: false,
      isEndDateModalOpen: false,
      startDate: format(new Date(), 'YYYY-MM-DD'),
      endDate: format(new Date(), 'YYYY-MM-DD'),

      isShowConfirmationDelete: false,
      isShowTimeEntrySheet: false,
      timeEntry: null as null | any,
      selectedItems: [] as any[],
      clients: [] as any[],
      projects: [] as any[],
      user: null as any,
      gridOptions: {
        rowHeight: 38
      } as any,
      gridApi: null as any | null,
      columnApi: null as any | null,
      columnDefs: [] as any[],

      previousInvoices: [] as any[],
      previousProjects: [] as any[],

      timeEntries: [] as any[],
      rowData: [] as any[],
      isSaving: false,
      isEdit: false,
      users: [] as any[],
      employee_id: 'all' as any,
    }
  },
  async mounted() {
    if (this.isAdmin) {
      await this.getUsers();
    }
    
    // set all values from query params if exist
    const queryParams = new URLSearchParams(window.location.search);
    const start = queryParams.get('start');
    const end = queryParams.get('end');
    const employeeId = queryParams.get('employeeId');
    const allDates = queryParams.get('allDates');
    
    if (start) {
      this.startDate = start;
    }

    if (end) {
      this.endDate = end;
    }

    if (employeeId) {
      this.employee_id = employeeId;
    }

    if (allDates === '1') {
      this.isShowAllDates = true;
    }

    await this.getClients();
    await this.getWorkTypes();
    await this.getTimesheetEntries();
    // await this.getProjects();

    this.employee_id = this.$store.state.account.id;

    this.gridOptions.rowClassRules = {
      'record-unbillable': (params: any) => {
        const record = this.timeEntries.find(x => x.id == params.data.id);
        return record.billable != null && !record.billable;
      },
      'record-billed': (params: any) => {
        const record = this.timeEntries.find(x => x.id == params.data.id);
        return record.billed_at;
      },
    };

    this.gridOptions.getRowNodeId = (data: any) => {
      return data.id;
    };

    this.columnDefs = [
      {
        headerName: 'Actions',
        editable: false,
        colId: 'params',
        field: 'value',
        cellRendererFramework: ActionCellRenderer,
        cellRendererParams: {
          getSelectedStatus: this.getSelectedStatus,
          toggle: this.toggleEntry,
          remove: this.confirmRemoveEntry,
          edit: this.editEntry,
          // billed: this.recordBilled
        },
        width: 150
      },
      {
        headerName: 'Date',
        field: 'started_at',
        sortable: true,
        filter: true,
        editable: false,
        cellRendererFramework: DateCellRenderer,
        cellRendererParams: {
          // format: 'ddd/DD/YYYY - hh:mm A'
          format: 'ddd, MMMM DD, YYYY'
        },
        width: 150,
        comparator: compareAsc
      },
      {
        headerName: 'Start',
        field: 'started_at',
        sortable: true,
        filter: true,
        editable: false,
        cellRendererFramework: DateCellRenderer,
        cellRendererParams: {
          format: 'hh:mm A'
        },
        width: 100
      },
      {
        headerName: 'End',
        field: 'ended_at',
        sortable: true,
        filter: true,
        editable: false,
        cellRendererFramework: DateCellRenderer,
        cellRendererParams: {
          format: 'hh:mm A'
        },
        width: 100
      },
      {
        headerName: 'Time',
        field: 'time',
        sortable: true,
        filter: true,
        cellRendererFramework: TimeCellRenderer,
        cellRendererParams: {
          calculate: this.calculateTime
        },
        width: 80
      },
      {
        headerName: 'Client',
        field: 'client_id',
        sortable: true,
        filter: true,
        editable: false,
        valueFormatter: (params: any) => {
          return this.renderClientName('client_id', params.data);
        },
        valueGetter: (params: any) => {
          return this.renderClientName('client_id', params.data);
        },
      },
      {
        headerName: 'Project',
        field: 'project',
        sortable: true,
        filter: true,
        editable: false
      },
      this.isAdmin ? {
        headerName: 'Employee',
        field: 'employee_id',
        sortable: true,
        filter: true,
        editable: false,
        valueFormatter: (params: any) => {
          return this.renderEmployeeName("employee_id", params.data);
        },
        valueGetter: (params: any) => {
          return this.renderEmployeeName("employee_id", params.data);
        },
        width: 150
      } : false,
      this.isAdmin ? {
        headerName: 'Entered By',
        field: 'entered_by',
        sortable: true,
        filter: true,
        editable: false,
        valueFormatter: (params: any) => {
          return this.renderEmployeeName("entered_by", params.data);
        },
        valueGetter: (params: any) => {
          return this.renderEmployeeName("entered_by", params.data);
        },
        width: 150
      } : false,
      {
        headerName: 'Work Type',
        field: 'work_type_id',
        sortable: true,
        filter: true,
        editable: false,
        valueFormatter: (params: any) => {
          return this.renderWorkType(params.data);
        },
        valueGetter: (params: any) => {
          return this.renderWorkType(params.data);
        },
        width: 150
      },
      {
        headerName: 'Tickets',
        field: 'ticket_ids',
        sortable: true,
        filter: true,
        editable: false,
        cellRendererFramework: TagCellRenderer,
        valueFormatter: (params: any) => {
          if (!params.value) {
            return [];
          }

          return params.value.split(",").map((x: string) => {
            return x.trim();
          });
        },
      },
      {
        headerName: 'Notes',
        field: 'notes',
        sortable: true,
        filter: true,
        editable: false,
        width: 400
      },
      this.isAdmin ? {
        headerName: 'Invoice',
        field: 'invoice_number',
        sortable: true,
        filter: true,
        editable: false,
        width: 200
      } : false,
      this.isAdmin ? {
        headerName: 'Billed',
        field: 'billed_at',
        sortable: true,
        filter: true,
        editable: true,
        cellRenderer: (params: any) => {
          return `${params.value ? `<span class='date-value ml-1'>${format(params.value, 'ddd, MMM DD, YYYY')}</span>` : ''}`;
        }
      } : false,
      this.isAdmin ? {
        headerName: 'Billable',
        field: 'billable',
        sortable: true,
        filter: true,
        editable: true,
        cellRenderer: (params: any) => {
          return `<input type='checkbox' disabled="disabled" ${params.value ? 'checked' : ''} />`;
        }
      } : false
    ]
  },
  computed: {
    isAdmin() {
      return this.$store.state?.isAdmin;
    },
    summaries() {
      if (!this.gridApi) {
        return [];
      }
      
      // show the visible items
      
      const model = this.gridApi.getModel();
      const rows = model.rowsToDisplay;

      // if any are selected, show the selected items instead filtered by the visible only
      if (this.selectedItems.length > 0) {
        return this.selectedItems.filter((item: any) => rows.some((row: any) => row.data.id === item.id));
      }
      
      return rows.map((row: any) => row.data);
    },
    isAllSelected() {
      // return if all is selected
      return this.selectedItems.length === this.timeEntries.length;
    },
    userOptions() {
      return [
        { 
          id: 'all',
          full_name: 'All' 
        },
        ...this.users
      ];
    },
    gridStyles() {
      const top = 200;
      return `width: 100%; height: calc(100vh - ${top}px);`
    },
    filteredData() {
      return this.timeEntries;
    },
    client() {
      return this.$store.state.client;
    },
  },
  methods: {
    clearSelectedItems() {
      this.selectedItems = [];
      this.timeEntries.forEach((entry: any) => {
        entry.selected = false;
      });
    },
    toggleAll() {
      // check all visible
      const model = this.gridApi.getModel();
      const rows = model.rowsToDisplay;

      if (this.isAllSelected) {
        this.selectedItems = [];
        rows.forEach((row: any) => {
          row.data.selected = false;
        });
      } else {
        this.selectedItems = rows.map((row: any) => row.data);
        rows.forEach((row: any) => {
          row.data.selected = true;
        });
      }
    },
    toggleAllDates() {
      // clear ent<3tyson55
      this.timeEntries = [];
      this.rowData = [];

      this.isShowAllDates = !this.isShowAllDates;
      
      if (this.isShowAllDates) {
        this.getTimesheetEntries(this.employee_id);
      }
    },
    async filterByUser(userId: string) {
      if (userId === 'all') {
        this.employee_id = userId;
        this.getTimesheetEntries('all');
        return;
      }

      this.employee_id = userId;
      this.getTimesheetEntries(userId);
    },
    async getUsers() {
      try {
        const { data } = await axios.get('/users');
        this.users = data;
      } catch (e) {
        console.error(e);
      }
    },
    renderEmployeeName(field: string, record: any) {
      if (record[field]) {
        const user = this.users.find(x => x.id == record[field]);
        
        if (user) {
            return user.first_name + ' ' + user.last_name
        }
      }
    },
    resetStartDate() {
      this.startDate = format(new Date(), 'YYYY-MM-DD');
      this.getTimesheetEntries();
    },
    resetEndDate() {
      this.endDate = format(new Date(), 'YYYY-MM-DD');
      this.getTimesheetEntries();
    },
    updateQueryParamState() {
        // update the query params to reflect the new date
        const query = new URLSearchParams({
          start: this.startDate,
          end: this.endDate,
          employeeId: this.employee_id,
          allDates: this.isShowAllDates ? '1' : '0'
        }).toString();
        window.history.replaceState(null, '', `?${query}`);
    },
    updateStartDate(date: Date) {
      this.startDate = format(date, 'YYYY-MM-DD');
      this.getTimesheetEntries();
      
      this.updateQueryParamState();
    },
    updateEndDate(date: Date) {
      this.endDate = format(date, 'YYYY-MM-DD');
      this.getTimesheetEntries();

      this.updateQueryParamState();
    },
    closeTimeEntryForm() {
      this.isShowTimeEntrySheet = false;
      this.timeEntry = null;
    },
    async cancelDeleteTimeEntry(): Promise<void> {
      this.isShowConfirmationDelete = false
    },
    async deleteTimeEntry(): Promise<void> {
      if (!this.timeEntry) {
        this.isShowConfirmationDelete = false;
        return;
      }

      try {
        await axios.delete(`/time-entries/${this.timeEntry.id}`);
        const oldEntry = this.timeEntries.find((x: any) => x.id === this.timeEntry.id);
        const index = this.timeEntries.indexOf(oldEntry);

        if (index > -1) {
          this.timeEntries.splice(index, 1);
          this.rowData = [...this.timeEntries];
        }
      } catch (e) {
        console.error(e);
      }

      this.isShowConfirmationDelete = false;
    },
    recordBilled(data: any) {
      const record = this.timeEntries.find(x => x.id == data.id);
      if (!record) {
        return null;
      }

      return record.billed_at;
    },
    editEntry(data: any) {
      this.timeEntry = this.timeEntries.find(x => x.id == data.id);
      this.isShowTimeEntrySheet = true;
    },
    confirmRemoveEntry(data: any) {
      this.timeEntry = this.timeEntries.find(x => x.id == data.id);

      if (!this.timeEntry) {
        return;
      }

      this.isShowConfirmationDelete = true;
    },
    getSelectedStatus(data: any): boolean {
      return !!this.selectedItems.find(x => x.id == data.id);
    },

    toggleEntry(data: any) {
      const timeEntry = this.timeEntries.find(x => x.id == data.id);
      const index = this.selectedItems.indexOf(timeEntry);

      if (index > -1) {
        timeEntry.selected = false;
        this.selectedItems.splice(index, 1);
      } else {
        timeEntry.selected = true;
        this.selectedItems.push(timeEntry);
      }
    },
    async getTimesheetEntries(userId = ''): Promise<void> {
      // CASE: if userId is provided, we treat as a filter, API will use the token's user ID on /my api
      const baseUrl = userId ? '/time-entries/filter' : '/my/timesheet-entries';
      
      try {
        const query = new URLSearchParams({
          start: this.startDate,
          end: this.endDate,
          employeeId: userId,
          allDates: this.isShowAllDates ? '1' : '0'
        }).toString();
        
        const { data } = await axios.get(`${baseUrl}?${query}`);
        this.timeEntries = data;
        this.rowData = [...this.timeEntries];
      } catch (e) {
        console.error(e);
      }
    },
    async getWorkTypes(): Promise<void> {
      try {
        const result = await axios.get('/settings/worktypes');
        this.$store.dispatch('SET_WORKTYPES', result.data);
      } catch (e) {
        console.error(e);
      }
    },
    // renderEmployeeColumn(field: string, record: any) {
    //   if (record[field]) {
    //     const user = this.users.find(x => x.id == record[field]);

    //     if (user) {
    //       return user.first_name + ' ' + user.last_name
    //     }
    //   }
    // },
    renderWorkType(data: any): string {
      console.log("worktype data", data)
      const workType = this.$store.state.workTypes.find((x: any) => x.id === data.work_type_id);
      if (!workType) {
        return '';
      }

      return workType.name;
    },
    renderClientName(field: string, data: any): string {
      const client = this.clients.find((x: any) => x.id === data.client_id);
      if (!client) {
        return '';
      }

      return client.name;
    },
    onGridReady({ api, columnApi }: any) {
        this.gridApi = api;
        this.columnApi = columnApi;
    },
    calculateTime(data: any): string | number {
      const record = this.timeEntries.find(x => x.id == data.id);

      if (!record || !record.ended_at) {
        return ''
      }

      return Math.ceil((differenceInMinutes(record.ended_at, record.started_at) / 60) * 10) / 10;
    },
    openTimeEntry() {
      this.isShowTimeEntrySheet = true;
    },
    async saveTimeEntry({ isEdit, timeEntry }: { isEdit: boolean; timeEntry: any }) {
      if (this.isSaving) {
        return;
      }

      this.trackInvoiceNumber(timeEntry.invoice_number);
      this.trackProject(timeEntry.project);

      this.isSaving = true;
      this.timeEntry = null;

      if (timeEntry.billed_date) {
        timeEntry.billed_at = new Date(timeEntry.billed_at);
      }

      // CASE: timed out but still trying to enter
      localStorage.setItem('redirect_uri', window.location.pathname);
      localStorage.setItem('time_entry', JSON.stringify(timeEntry));

      let isUpdateSheet = true;

      if (this.$store.state.client && this.$store.state.client.id) {
        isUpdateSheet = this.$store.state.client.id === timeEntry.client_id;
      }

      if (isEdit && timeEntry.id) {
        try {
          const result = await this.$axios.put(`/time-entries/${timeEntry.id}`, timeEntry);
          const oldEntry = this.timeEntries.find((x: any) => x.id === timeEntry.id);
          const index = this.timeEntries.indexOf(oldEntry);

          if (index > -1) {
            const model = this.gridOptions.api.getModel();
            const row = model.rowsToDisplay.find((x: any) => x.data.id === timeEntry.id);

            // TODO: review check for case in timesheetentries
            if (isUpdateSheet) {
              this.timeEntries.splice(index, 1, result.data);
              row.setData(result.data);

              for (let i = 0; i < this.rowData.length; i++) {
                if (this.rowData[i].id === timeEntry.id) {
                  this.rowData[i] = Object.assign(this.rowData[i], result.data);
                }
              }
            } else {
              this.timeEntries.splice(index, 1);
              this.rowData = [...this.timeEntries];
            }
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        try {
          const result = await this.$axios.post('/time-entries', timeEntry);

          if (isUpdateSheet) {
            // CASE: find a record to insert before
            // TODO: improve sorting
            const record = this.timeEntries.find(x => x.started_at < result.data.started_at);

            if (record) {
              const index = this.timeEntries.indexOf(record);

              if (index > -1) {
                this.timeEntries.splice(index, 0, result.data);
                this.rowData = [...this.timeEntries];
              }
            } else {
              this.timeEntries.push(result.data);
              this.rowData = [...this.timeEntries];
            }
          }
        } catch (e) {
          alert("Failed to save time entry")
          console.error(e);
        }
      }

      this.trackInvoiceNumber(timeEntry.invoice_number);
      this.trackProject(timeEntry.project);
      this.trackClient(timeEntry.client_id);

      this.isSaving = false;
      this.timeEntry = null;

      localStorage.removeItem('redirect_uri');
      localStorage.removeItem('time_entry');
    },
    async getClients() {
      try {
        const { data } = await axios.get('/my/clients');
        this.clients = data;

        this.$store.dispatch('SET_CLIENTS', data);
      } catch (e) {
        console.error(e);
      }
    },
    trackInvoiceNumber(invoice: string | null) {
      if (!invoice) {
        return;
      }

      if (this.previousInvoices.indexOf(invoice) == -1) {
        this.previousInvoices.unshift(invoice);
      }

      this.previousInvoices = this.previousInvoices.slice(0, 2);
    },
    trackProject(project: string | null) {
      if (!project) {
        return;
      }

      if (this.previousProjects.indexOf(project) == -1) {
        this.previousProjects.unshift(project);
      }

      this.previousProjects = this.previousProjects.slice(0, 2);
    },
    trackClient(clientId: string | null) {
      if (!clientId) {
        return;
      }

      this.$store.dispatch('SET_CLIENT_ID', clientId);
    },
    async getProjects() {
      try {
        const result = await axios.get(`/projects`);
        this.projects = _.orderBy(result.data, ['name'], ['asc']);
      } catch (e) {
        console.error(e);
      }
    },
  }
});
